import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const containerStyle = {
  width: "100%",
  height: "200px",
  marginBottom: 40,
  marginTop: 40,
};

const center = {
  lat: 52.38112197978813,
  lng: 16.884142215802274,
};

const MapGoogle = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap defaultZoom={13} defaultCenter={center}>
      <Marker position={center} />
    </GoogleMap>
  ))
);

const MapGoogleComponent = () => (
  <MapGoogle
    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
    loadingElement={<div style={containerStyle} />}
    containerElement={<div style={containerStyle} />}
    mapElement={<div style={{ height: `100%` }} />}
  />
);

export default MapGoogleComponent;
